import { Component } from '@angular/core';
import { ButtonComponent } from '../core/buttons/button.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { DialogComponent } from '../core/panels/dialog.component';
@Component({
  selector: 'app-dialog-design',
  imports: [DialogComponent, ActionRowComponent, ButtonComponent],
  template: `
    <button (click)="dialog.visible = true">show dialog</button>
    <app-dialog #dialog label="Confirm">
      <ng-template #content>
        <div class="tw-pb-4">Confirm the action</div>
        <app-action-row>
          <app-button
            icon="fa-check fa-light"
            (click)="dialog.visible = false"
            right1
            label="Confirm"
          />
          <app-button
            (click)="dialog.visible = false"
            emphasis="Low"
            right2
            label="Cancel"
          />
        </app-action-row>
      </ng-template>
    </app-dialog>
  `,
  styles: ``,
})
export class DialogDesignComponent {}
